import { find } from "../utils/dom";
import gsap from "gsap";
import Swiper from "swiper";

const PageExposicoesTemporariasSingle = () =>{
	const page = find("[js-page='exposicoes-temporarias-single']");
	if(!page) return;


	const tl = gsap.timeline({
		scrollTrigger: {
			scrub: 1,
			pin: true,
			trigger: "#item-fixed",
			start: "50% 50%",
			endTrigger: "#content",
			end: "bottom 100%",
		},
	});

	const SwiperGaleria = new Swiper(".swiper-galeria",{
		spaceBetween: 20,
		slidesPerView: 'auto',
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints:{
			767:{
				spaceBetween: 32,
				pagination:{
					dynamicBullets: false
				}
			}
		}
	})
}

export default PageExposicoesTemporariasSingle;